import { useLARequirements } from '@/features/applications/faculty/CreateApplicationSection3';

/**
 * What the Accept dialog needs beyond the offer: the LA program's training
 * dates and commitments for the term, and whether the student said they are
 * returning. Asked for only while an offer is open on an LA application;
 * until it loads (or if it fails) the offer shows without them.
 */
export default function useAcceptInfo(application, enabled) {
    const wanted = Boolean(enabled) && application?.program === 'la';
    const { requirements } = useLARequirements(application?.term, wanted);
    if (!wanted) return undefined;
    return {
        sessions: requirements?.trainingSessions || [],
        commitments: requirements?.studentCommitments || [],
        isReturning: application.laDetails?.isReturning,
    };
}
